// File: src/pages/admin/AdminLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import tw from "twin.macro";

const LayoutContainer = tw.div`flex h-screen bg-gray-100`;
const MainContent = tw.div`flex-1 flex flex-col overflow-hidden`;
const ContentArea = tw.main`flex-1 overflow-y-auto p-6`;

export default function AdminLayout() {
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent>
        <Navbar />
        <ContentArea>
          <Outlet /> {/* This is where nested routes (like Dashboard, Users) will be rendered */}
        </ContentArea>
      </MainContent>
    </LayoutContainer>
  );
}
